//scss
import "./assets/scss/socialv.scss"
import './assets/scss/custom.scss'
import "./assets/scss/customizer.scss"
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import "choices.js/public/assets/styles/choices.min.css";
import "flatpickr/dist/flatpickr.css";

// Redux Selector / Action
import { useDispatch } from 'react-redux';

// import state selectors
import { setSetting } from './store/setting/actions'
import "./assets/custom/scss/socialv-custom.scss"

// Language Provider
import { LanguageProvider } from './components/LanguageSwitcher'


function App({ children }) {
  const dispatch = useDispatch()
  dispatch(setSetting())

  return (
    <LanguageProvider>
      <div className="App">
        {/* <IndexRouters /> */}
        {children}
      </div>
    </LanguageProvider>
  );
}

export default App;
